import React, { useState } from 'react';

const ImageWithFallback = ({ src, alt, className, onLoad, onError }) => {
  const [isValid, setIsValid] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);

  const handleError = () => {
    setIsValid(false);
    if (onError) onError();
  };

  const handleLoad = () => {
    setIsLoaded(true);
    if (onLoad) onLoad();
  };

  if (!isValid) {
    return null; // Don't render broken images
  }

  return (
    <img
      src={src}
      alt={alt}
      className={`${className} ${isLoaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}
      onError={handleError}
      onLoad={handleLoad}
    />
  );
};

export default ImageWithFallback;


